// @flow
import React from 'react';

import { BaseMessageContainer } from './BaseMessageContainer';

export const InfoMessageContainer = ({ message, link, key = '', compact = false }) => {
  if (!message) {
    return null;
  }
  return (
    <BaseMessageContainer color="blue" compact={compact} key={key} link={link} message={message} />
  );
};
